import { render, staticRenderFns } from "./LandNewHomes.vue?vue&type=template&id=6df7689b&"
import script from "./LandNewHomes.vue?vue&type=script&lang=js&"
export * from "./LandNewHomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports